export default "__VITE_ASSET__BFyfLvgt__"